const MOYASAR_CSS_URL = 'https://cdn.moyasar.com/mpf/1.14.0/moyasar.css';
const MOYASAR_JS_URL = 'https://cdn.moyasar.com/mpf/1.14.0/moyasar.js';

let assetsPromise = null;

function loadStylesheet(href) {
  if (document.querySelector(`link[href="${href}"]`)) {
    return;
  }
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}

function loadScript(src) {
  const existing = document.querySelector(`script[src="${src}"]`);
  if (existing) {
    return new Promise((resolve, reject) => {
      if (window.Moyasar) {
        resolve(window.Moyasar);
        return;
      }
      existing.addEventListener('load', () => resolve(window.Moyasar));
      existing.addEventListener('error', reject);
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => {
      if (window.Moyasar) {
        resolve(window.Moyasar);
      } else {
        reject(new Error('Moyasar library loaded but Moyasar global is missing'));
      }
    };
    script.onerror = () => reject(new Error('Failed to load Moyasar payment form'));
    document.body.appendChild(script);
  });
}

/**
 * Load Moyasar Payment Form assets once per session.
 * @returns {Promise<typeof window.Moyasar>}
 */
export function loadMoyasarFormAssets() {
  if (window.Moyasar) {
    return Promise.resolve(window.Moyasar);
  }
  if (!assetsPromise) {
    assetsPromise = (async () => {
      loadStylesheet(MOYASAR_CSS_URL);
      return loadScript(MOYASAR_JS_URL);
    })().catch((err) => {
      assetsPromise = null;
      throw err;
    });
  }
  return assetsPromise;
}
